export default "__VITE_ASSET__0_s91Wah__"